import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PatternStatus } from './joblog-pattern.service';

export type LogMatcherFilters = {
  linkId: number | null;
  jobLogType: number | null;
  fromApplicationId: number | null;
  toApplicationId: number | null;
  take: number;
  enforceOrder: boolean;
};

export type DraftPattern = {
  title: string;
  pattern: string;
  category: string | null;
  status: PatternStatus;

  // Constraints to apply when saving
  linkId: number | null;
  jobLogType: number | null;
  fromApplicationId: number | null;
  toApplicationId: number | null;
  linkTypeId: number | null;
  description?: string | null;
  freshdeskArticleIds?: number[] | null;
};

@Injectable({ providedIn: 'root' })
export class LogMatcherContextService {
  readonly filters$ = new BehaviorSubject<LogMatcherFilters>({
    linkId: null,
    jobLogType: null,
    fromApplicationId: null,
    toApplicationId: null,
    take: 100,
    enforceOrder: true,
  });

  readonly draft$ = new BehaviorSubject<DraftPattern>({
    title: '',
    pattern: '',
    category: null,
    status: 1,
    linkId: null,
    jobLogType: null,
    fromApplicationId: null,
    toApplicationId: null,
    linkTypeId: null,
  });

  readonly seedMessage$ = new BehaviorSubject<string>('');
}

/**
 * Convert a raw log message into a more reusable pattern by replacing
 * variable-ish segments (guids/emails/long numbers/amounts) with <VAR>.
 */
export function toVarPattern(message: string): string {
  if (!message) return '';

  let s = message;

  // GUIDs
  s = s.replace(
    /\b[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}\b/g,
    '<VAR>'
  );

  // Emails
  s = s.replace(/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi, '<VAR>');

  // Long numeric ids (>=4 digits)
  s = s.replace(/\b\d{4,}\b/g, '<VAR>');

  // Amounts like 12.34 / 12,34
  s = s.replace(/\b\d+(?:[.,]\d{2})\b/g, '<VAR>');

  // Collapse repeated <VAR>
  s = s.replace(/(?:<VAR>\s*){2,}/g, '<VAR> ');

  return s.trim();
}
